export default __webpack_public_path__ + "img_default_profile.6b8f49b0.svg";